"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends4 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames3 = _interopRequireDefault(require("classnames"));

var _overrides = require("../../../utils/overrides");

var _Label = _interopRequireDefault(require("../Label"));

var _CheckboxControl = _interopRequireDefault(require("./CheckboxControl"));

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'CheckboxGroup');

function CheckboxGroup(_ref) {
  var _classnames;

  var children = _ref.children,
      classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      options = _ref.options,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      value = _ref.value,
      label = _ref.label,
      labelMode = _ref.labelMode,
      hint = _ref.hint,
      error = _ref.error,
      isReadOnly = _ref.isReadOnly,
      isFullWidth = _ref.isFullWidth,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "overrides", "className", "options", "onChange", "onBlur", "value", "label", "labelMode", "hint", "error", "isReadOnly", "isFullWidth"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, CheckboxGroup.overrides); // Classes

  var rootClassName = (0, _classnames3.default)(classes.root, (_classnames = {}, (0, _defineProperty2.default)(_classnames, classes.isReadOnly, isReadOnly === true), (0, _defineProperty2.default)(_classnames, classes[labelMode], labelMode), (0, _defineProperty2.default)(_classnames, classes.errored, error), _classnames), classNameProp);
  var formControlClassName = (0, _classnames3.default)(classes.formControl, (0, _defineProperty2.default)({}, classes.isFullWidth, isFullWidth));
  var rootProps = {
    className: rootClassName
  };
  var labelProps = (0, _extends4.default)({
    className: classes.Label,
    hint: hint
  }, override.Label);
  var onChangeCheckbox = (0, _react.useCallback)(function (option) {
    onChange && onChange((0, _extends4.default)({}, value, (0, _defineProperty2.default)({}, option, !value[option])));
    onBlur && onBlur((0, _extends4.default)({}, value, (0, _defineProperty2.default)({}, option, !value[option])));
  }, [onBlur, onChange, value]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends4.default)({}, rootProps, override.root), label && /*#__PURE__*/_react.default.createElement(_Label.default, labelProps, label), /*#__PURE__*/_react.default.createElement("div", (0, _extends4.default)({
    className: formControlClassName
  }, override.formControl), options.map(function (option, i) {
    return /*#__PURE__*/_react.default.createElement(_CheckboxControl.default, {
      key: option.value,
      option: option,
      value: value[option.value],
      isReadOnly: Array.isArray(isReadOnly) ? isReadOnly[i] : isReadOnly,
      onChange: onChangeCheckbox,
      overrides: overridesProp
    });
  }), error && /*#__PURE__*/_react.default.createElement("div", (0, _extends4.default)({
    className: classes.error
  }, override.error), error)));
}

CheckboxGroup.overrides = ['root', 'error', 'Checkbox', 'checkboxLabel', 'checkboxControl', 'formControl', 'Label'];
CheckboxGroup.defaultProps = {
  labelMode: 'horizontal',
  onChange: function onChange() {},
  value: {},
  options: [],
  isReadOnly: false,
  overrides: {}
};
process.env.NODE_ENV !== "production" ? CheckboxGroup.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  onChange: _propTypes.default.func,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string
  })),
  value: _propTypes.default.object,
  error: _propTypes.default.string,
  label: _propTypes.default.string,
  labelMode: _propTypes.default.oneOf(['horizontal', 'vertical']),

  /** Info popover */
  hint: _propTypes.default.string,
  isReadOnly: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.array]),
  isFullWidth: _propTypes.default.bool
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(CheckboxGroup);

exports.default = _default;